import React, { useState } from 'react';
import { Link } from 'gatsby';
import clsx from 'clsx';
import * as styles from './SiteHeader.module.scss';
import { IconLogo, IconHeaderLink } from '../../icons';

const SiteHeader = React.forwardRef((props, ref) => {
  const {
    className,
    isHomePage = false,
    ...other
  } = props;

  /**
   * ドロワーメニュー開閉用の state
   */
  const [visible, setVisibility] = useState(false);

  /**
   * ドロワーメニュー開閉ボタンの Click Event のコールバック関数
   */
  function drawerToggle() {
    setVisibility(!visible);
  }

  function addressCheck(e) {
    const aria = e.target.ariaCurrent;
    if (aria) setVisibility(!visible);
  }

  return (
    <header
      ref={ref}
      className={clsx(styles.wrapper, className)}
      data-is-root-path={isHomePage}
      {...other}
    >
      <h1 className={styles.logo}>
        <Link to="/" aria-label="会津ラボのホームページへ">
          <IconLogo width="153" height="40" />
        </Link>
      </h1>
      <button className={clsx(styles.button, visible && styles.active)} onClick={drawerToggle} aria-label="メニューを開閉する">
        <span />
        <span />
      </button>
      <ul className={styles.nav}>
        <li className={styles.navItem}>
          <Link
            to="/"
            className={styles.navLink}
            activeClassName={styles.active}
          >
            トップ
          </Link>
        </li>
        <li className={styles.navItem}>
          <Link
            to="/cases/"
            className={styles.navLink}
            activeClassName={styles.active}
          >
            開発事例
          </Link>
        </li>
        <li className={styles.navItem}>
          <Link
            to="/company/"
            className={styles.navLink}
            activeClassName={styles.active}
          >
            会社情報
          </Link>
        </li>
        <li className={styles.navItem}>
          <Link
            to="/blog/"
            className={styles.navLink}
            activeClassName={styles.active}
          >
            ブログ
          </Link>
        </li>
        <li className={styles.navItem}>
          <Link
            to="/contact/"
            className={styles.navLink}
            activeClassName={styles.active}
          >
            お問い合わせ
          </Link>
        </li>
        <li className={styles.navItem}>
          <Link
            to="/recruit/"
            className={styles.navLink}
            activeClassName={styles.active}
          >
            採用情報
          </Link>
        </li>
      </ul>
      <div className={clsx(styles.drawer, visible && styles.opened)}>
        <ul className={styles.nav}>
          <li className={styles.navItem}>
            <Link
              onClick={addressCheck}
              to="/"
              className={styles.navLink}
              activeClassName={styles.active}
            >
              トップ
            </Link>
          </li>
          <li className={styles.navItem}>
            <Link
              onClick={addressCheck}
              to="/cases/"
              className={styles.navLink}
              activeClassName={styles.active}
            >
              開発事例
            </Link>
          </li>
          <li className={styles.navItem}>
            <Link
              onClick={addressCheck}
              to="/company/"
              className={styles.navLink}
              activeClassName={styles.active}
            >
              会社情報
            </Link>
          </li>
          <li className={styles.navItem}>
            <Link
              onClick={addressCheck}
              to="/blog/"
              className={styles.navLink}
              activeClassName={styles.active}
            >
              ブログ
            </Link>
          </li>
          <li className={styles.navItem}>
            <Link
              onClick={addressCheck}
              to="/contact/"
              className={styles.navLink}
              activeClassName={styles.active}
            >
              お問い合わせ
            </Link>
          </li>
          <li className={styles.navItem}>
            <Link
              onClick={addressCheck}
              to="/recruit/"
              className={styles.navLink}
              activeClassName={styles.active}
            >
              採用情報
            </Link>
          </li>
        </ul>
        {/* <ul className={styles.list}>
          <li className={styles.listItemDisabled}>JP</li>
          <li className={styles.listItemDisabled}>EN</li>
        </ul> */}
      </div>
    </header>
  );
});

export default SiteHeader;
